<template>
  <div class='settlement-dialog'>
    <el-dialog width="60%" title="医保结算" :visible.sync="showSettlementDialog" append-to-body :close-on-click-modal="false">
      <div style="margin-top: 20px">
        <el-form>
          <el-form-item label="医保药品费用总额：">
            <span>{{ 0 }} 元</span>
            <el-button type="primary" size="mini" style="margin-left: 50px;" @click="cardReading(1)">读卡</el-button>
            <el-button type="primary" size="mini" style="margin-left: 50px;" @click="cardReading(3)">读卡</el-button>
          </el-form-item>
        </el-form>
        <el-row style="margin-bottom: 20px">
          预结算前请选择：
          <el-radio-group v-model="preSettlementMethod" disabled="0">
            <el-radio :label="0">不使用</el-radio>
            <el-radio :label="1">使用本人个账</el-radio>
            <el-radio :label="2">使用共济人个账</el-radio>
          </el-radio-group>
        </el-row>
        <div style="text-align: center; margin-top: 40px;">
          <el-button @click="pre" type="primary" size="small">取消</el-button>
          <el-button @click="preSettlement" type="primary" size="small">预结算</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'settlement-dialog',
  components: {},
  data () {
    return {
      preSettlementMethod: ''
    };
  },
  created () { },
  mounted () { },
  props: {
    showSettlementDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  watch: {},
  methods: {
    // 读卡
    cardReading (e) {
      this.$emit('cardReading', e)
    },
    // 取消
    pre () { },
    // 预结算
    preSettlement () { },
  },
}
</script>
<style lang='scss' scoped>
.settlement-dialog {}
</style>